/*
  Footer behaviour: mobile link-list accordions and the back-to-top button.

  Both are progressive enhancements. The <details> elements are rendered with
  `open` already set, so a visitor without JavaScript sees every column
  expanded instead of a footer they cannot open; this script only *closes*
  them once it knows the viewport is narrow.
*/
(function () {
  'use strict';

  var MOBILE_QUERY = '(max-width: 989px)';

  function setupAccordions(root) {
    var footer = root.querySelector('.footer--accordion');
    if (!footer) return;

    var panels = footer.querySelectorAll('.footer-block--collapsible');
    if (!panels.length) return;

    var mql = window.matchMedia(MOBILE_QUERY);

    var apply = function () {
      var isMobile = mql.matches;
      panels.forEach(function (details, index) {
        if (isMobile) {
          // Keep the first column open so the footer never looks empty.
          details.open = index === 0 && footer.dataset.footerFirstOpen === 'true';
        } else {
          details.open = true;
        }
      });
    };

    apply();

    // Keyboard users can still activate the summary on desktop, where it is
    // only a heading — force it back open instead of hiding the column.
    panels.forEach(function (details) {
      details.addEventListener('toggle', function () {
        if (!mql.matches && !details.open) details.open = true;
      });
    });

    if (typeof mql.addEventListener === 'function') {
      mql.addEventListener('change', apply);
    } else if (typeof mql.addListener === 'function') {
      mql.addListener(apply);
    }
  }

  function setupBackToTop(root) {
    var button = root.querySelector('.footer__back-to-top');
    if (!button) return;

    var threshold = parseInt(button.dataset.showAfter, 10);
    if (isNaN(threshold)) threshold = 400;

    var ticking = false;
    var update = function () {
      button.classList.toggle('is-visible', window.scrollY > threshold);
      ticking = false;
    };

    var onScroll = function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    };

    window.addEventListener('scroll', onScroll, { passive: true });
    update();

    button.addEventListener('click', function () {
      var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      window.scrollTo({ top: 0, behavior: reduced ? 'auto' : 'smooth' });
    });
  }

  function init(root) {
    setupAccordions(root || document);
    setupBackToTop(root || document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  // Theme editor re-renders the section in place; re-bind against the new DOM.
  document.addEventListener('shopify:section:load', function (event) {
    if (event.target && event.target.querySelector('.footer')) {
      init(event.target);
    }
  });
})();
